import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';
import * as moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class HotelService {
  private pendingroomCollection: any;
  private pendingamendCollection: any;
  private pendingcancelCollection: any;
  private pendingGrouproomCollection: any;
  private pendingGroupamendCollection: any;
  private pendingGroupcancelCollection: any;
  private pendingBanquetroomCollection: any;
  private pendingBanquetamendCollection: any;
  private pendingBanquetcancelCollection: any;
  private roomCheckoutCollection: any;
  private groupCheckoutCollection: any;
  private banquetCheckoutCollection: any;
  private linkedHotelCollection: any;

  constructor(
    private firestore: AngularFirestore,
    public afs: AngularFirestore,
  ) {
    this.pendingroomCollection = this.afs.collection<any>('pendingRoom');
    this.pendingamendCollection = this.afs.collection<any>('pendingAmend');
    this.pendingcancelCollection = this.afs.collection<any>('pendingCancel');
    this.pendingGrouproomCollection = this.afs.collection<any>('pendingGroupRoom');
    this.pendingGroupamendCollection = this.afs.collection<any>('pendingGroupAmend');
    this.pendingGroupcancelCollection = this.afs.collection<any>('pendingGroupCancel');
    this.pendingBanquetroomCollection = this.afs.collection<any>('pendingBanquetRoom');
    this.pendingBanquetamendCollection = this.afs.collection<any>('pendingBanquetAmend');
    this.pendingBanquetcancelCollection = this.afs.collection<any>('pendingBanquetCancel');
    this.roomCheckoutCollection = this.afs.collection<any>('roomCheckout');
    this.groupCheckoutCollection = this.afs.collection<any>('groupCheckout');
    this.banquetCheckoutCollection = this.afs.collection<any>('banquetCheckout');
    this.linkedHotelCollection = this.afs.collection<any>('linkedHotels');

  }

  generateUniqNumber(length?: any) {
    var length = length || 8,
      charset = "0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  updateHotel(uid: string, data: any) {
    data['timeStamp'] = moment().format('x')
    return this.afs.doc('hotels/' + uid).set(data);
  }

  addHotel(data: any) {
    data['timeStamp'] = moment().format('x')
    return firebase.firestore().collection('hotels').add(data);
  }

  addGroupReq(data: any) {
    data['timeStamp'] = moment().format('x')
    return firebase.firestore().collection('groupreqs').add(data);
  }

  getGroupReqById(id: any) {

    return new Promise((resolve) => {
      var docRef = this.firestore.collection("groupreqs").doc(id);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  // updateBanquet(data: any) {
  //   return this.afs.doc('banquets/' + data.id).set(data);
  // }

  addTripSummary(data: any) {
    data['timeStamp'] = moment().format('x')
    return firebase.firestore().collection('tripSummary').add(data);
  }
  upDateTripSummary(data: any) {
    data.timeStamp = moment().format('x')
    return this.afs.doc('tripSummary/' + data.id).set(data)
  }
  getTripSummaryByRoomId(roomId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('tripSummary', (ref) =>
        ref.where("roomId", "==", roomId)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getTripSummaryByGroupId(groupId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('tripSummary', (ref) =>
        ref.where("groupId", "==", groupId)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }
  getTripSummaryByBanquetId(groupReqId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('tripSummary', (ref) =>
        ref.where("groupReqId", "==", groupReqId)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  addBanquet(data: any) {
    data['timeStamp'] = moment().format('x')
    return firebase.firestore().collection('banquetMaster').add(data);
  }

  getBanquetByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('banquetMaster', (ref) =>
        ref.where("hotelId", "==", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  addSubscription(data: any) {
    data['timeStamp'] = moment().format('x')
    return firebase.firestore().collection('subscritionManagement').add(data);
  }

  getSubscriptionByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('subscritionManagement', (ref) =>
        ref.where("hotelId", "==", hotelId)
          .orderBy("timeStamp", 'desc')
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getSubscriptionByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('subscritionManagement', (ref) =>
        ref.where("corpId", "==", corpId)
          .orderBy("timeStamp", 'desc')
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  // getHotelUsersById(hotelId: any) {
  //   return new Promise((resolve) => {
  //     this.firestore.collection('admins', (ref) =>
  //       ref
  //         .where("hotelId", "==", hotelId)
  //     ).snapshotChanges()
  //       .subscribe(users => {
  //         let contactList = users.map(item => {
  //           return {
  //             ...item.payload.doc.data() as {},
  //             id: item.payload.doc.id
  //           };
  //         });
  //         resolve(contactList);
  //       })
  //   })
  // }

  getSubscriptionById(id: any) {

    return new Promise((resolve) => {
      var docRef = this.firestore.collection("subscritionManagement").doc(id);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  deleteInventoryById(id) {
    return this.afs.doc('roomInventory/' + id).delete();
  }

  addRoomInventory(data: any) {
    data['timeStamp'] = moment().format('x')
    return firebase.firestore().collection('roomInventory').add(data);
  }

  addBookedRoomInventory(data: any) {
    data['timeStamp'] = moment().format('x')
    return firebase.firestore().collection('bookedRoomInventory').add(data);
  }

  getRoomInventoryByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('roomInventory', (ref) =>
        ref.where("hotelId", "==", hotelId)
          .orderBy("timeStamp", 'desc')
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getBookedRoomInventoryByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('bookedRoomInventory', (ref) =>
        ref.where("hotelId", "==", hotelId)
          .orderBy("timeStamp", 'desc')
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getRoomInventoryById(id: any) {

    return new Promise((resolve) => {
      var docRef = this.firestore.collection("roomInventory").doc(id);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  updateHotelUser(uid: string, user: any) {
    user.timeStamp = moment().format('x')
    return this.afs.doc('admins/' + uid).set(user);
  }

  getHotelUsers(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('admins', (ref) =>
        ref.where("hotelId", "==", hotelId)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getHotelUserById(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('admins', (ref) =>
        ref
          .where("hotelId", "==", hotelId)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getHotelUsersById(id: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection("admins").doc(id);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  addLinkedHotel(data: any) {
    data['timeStamp'] = moment().format('x')
    return firebase.firestore().collection('linkedHotels').add(data);
  }

  getLinkedHotelByCorpId(uid: any) {
    console.log(uid)
    return new Promise((resolve) => {
      this.firestore.collection('linkedHotels',
        ref => ref.where('corpId', '==', uid)).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getLinkedClientByCorpId(uid: any) {
    console.log(uid)
    return new Promise((resolve) => {
      this.firestore.collection('linkclients',
        ref => ref
          .where('corpId', '==', uid)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getApprovedLinkedClientByCorpId(uid: any) {
    console.log(uid)
    return new Promise((resolve) => {
      this.firestore.collection('linkclients',
        ref => ref.where('corpId', '==', uid)
          .where('status', '==', 'Corporate Accepted')
          .orderBy('timeStamp', 'desc')
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getApprovedLinkedClientByHotelId(uid: any) {
    console.log(uid)
    return new Promise((resolve) => {
      this.firestore.collection('linkclients',
        ref => ref.where('hotelId', '==', uid)
          .where('status', '==', 'Corporate Accepted')
          .orderBy('timeStamp', 'desc')
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getLinkedHotelById(id: any) {

    return new Promise((resolve) => {
      var docRef = this.firestore.collection("linkedHotels").doc(id);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  getLinkedCorpsByHotelId(uid: any) {
    return new Promise((resolve) => {
      this.firestore.collection('linkedCorps',
        ref => ref.where('hotelId', '==', uid)).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }


  getLinkedCorpsById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection("linkedCorps").doc(uid);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }


  getLinkedClientByHotelId(uid: any) {
    return new Promise((resolve) => {
      this.firestore.collection('linkclients',
        ref => ref
          .where('hotelId', '==', uid)
          .orderBy('createdAt', 'desc')
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getAllHotels() {
    return new Promise((resolve) => {
      this.firestore.collection('hotels').snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getHotelByUID(UID: any){
    return new Promise((resolve) => {
      this.firestore
        .collection('hotels', (ref) => ref.where('UID', '==', UID))
        .snapshotChanges()
        .subscribe((users) => {
          let Hotel = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(Hotel);
        });
    });
  }
  getAllHotels1(startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore.collection('hotels',
        ref => ref.orderBy('timeStamp', 'desc')
          .where('timeStamp', '>=', startDate)
          .where('timeStamp', '<=', endDate)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getConfirmedRoomsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('room', (ref) =>
        ref
          .where("status", "in", ['confirmed', 'Confirmed', 'Approved','Expired'])
          .where("hotelData.id", "==", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getAmendedRoomsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('room', (ref) =>
        ref
          .where("status", "in", ['confirmed', 'Confirmed', 'Approved','checkout'])
          .where("hotelData.id", "==", hotelId)
          .where("hotelReqType", "==", 'Amendment')
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }
  getAmendedGroupsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('group', (ref) =>
        ref
          .where("status", "in", ['confirmed', 'Confirmed', 'Approved','checkout'])
          .where("hotelData.id", "==", hotelId)
          .where("hotelReqType", "==", 'Amendment')
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getAmendedBanquetsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('banquet', (ref) =>
        ref
          .where("status", "in", ['confirmed', 'Confirmed', 'Approved','checkout'])
          .where("hotelData.id", "==", hotelId)
          .where("hotelReqType", "==", 'Amendment')
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }


  getCancellationRoomsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('room', (ref) =>
        ref
        // .where("status", "==", 'checkout')
          .where("status", "in", ['confirmed', 'Confirmed', 'Approved','checkout'])
          .where("hotelData.id", "==", hotelId)
          .where("hotelReqType", "==", 'Cancellation')
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }
  getCancellationGroupsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('group', (ref) =>
        ref
        // .where("status", "==", 'checkout')
          .where("status", "in", ['confirmed', 'Confirmed', 'Approved','checkout'])
          .where("hotelData.id", "==", hotelId)
          .where("hotelReqType", "==", 'Cancellation')
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }
  getCancellationBanquetsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('banquet', (ref) =>
        ref
        // .where("status", "==", 'checkout')
          .where("status", "in", ['confirmed', 'Confirmed', 'Approved','checkout'])
          .where("hotelData.id", "==", hotelId)
          .where("hotelReqType", "==", 'Cancellation')
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getRejectedRoomsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('room', (ref) =>
        ref
          .where("status", "==", 'rejected')
          .where("hotelId", "==", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getApprovedGroupsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('group', (ref) =>
        ref
          // .where("statusType", "==", 'CORP_PAID')
          // .where("status", "in", ['confirmed', 'Confirmed', 'Approved'])
        //  .where("status", "in", ['confirmed', 'Confirmed','Expired'])
          .where("status", "in", ['confirmed', 'Confirmed'])
          .where("hotelId", "==", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  // getExpiredGroupsByHotelId(hotelId: any) {
  //   return new Promise((resolve) => {
  //     this.firestore.collection('group', (ref) =>
  //       ref
  //         .where("status", "in", ['Expired'])
  //         .where("corpRejHotelIds", "array-contains", hotelId)
  //         .orderBy("timeStamp", "desc")
  //     ).snapshotChanges()
  //       .subscribe(users => {
  //         let contactList = users.map(item => {
  //           return {
  //             ...item.payload.doc.data() as {},
  //             id: item.payload.doc.id
  //           };
  //         });
  //         resolve(contactList);
  //       })
  //   })
  // }
  // getExpiredBanquetByHotelId(hotelId: any) {
  //   return new Promise((resolve) => {
  //     this.firestore.collection('banquet', (ref) =>
  //       ref
  //         .where("status", "in", ['Expired'])
  //         .where("corpRejHotelIds", "array-contains", hotelId)
  //         .orderBy("timeStamp", "desc")
  //     ).snapshotChanges()
  //       .subscribe(users => {
  //         let contactList = users.map(item => {
  //           return {
  //             ...item.payload.doc.data() as {},
  //             id: item.payload.doc.id
  //           };
  //         });
  //         resolve(contactList);
  //       })
  //   })
  // }

  getCorpRejGroupByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('group', (ref) =>
        ref
          .where("status", "==", 'Approved')
          .where("corpRejHotelIds", "array-contains", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getApprovedBanquetByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('banquet', (ref) =>
        ref
          // .where("statusType", "==", 'CORP_PAID')
          .where("status", "in", ['confirmed', 'Confirmed', 'Approved','Expired'])
          .where("hotelId", "==", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getCorpRejBanquetByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('banquet', (ref) =>
        ref
          .where("status", "==", 'Approved')
          .where("corpRejHotelIds", "array-contains", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getRejectedBanquetByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('rejectedBanquet', (ref) =>
        ref
          .where("hotelId", "==", hotelId)
          .orderBy('timeStamp', 'desc')
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }



  getRejectedGroupByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('rejectedGroup', (ref) =>
        ref
          .where("requestType", "==", "Cancellation")
          .where("hotelId", "==", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }
  getExpiredBanquetByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('expiredBanquet', (ref) =>
        ref
          // .where("requestType", "==", "Cancellation")
          .where("hotelId", "==", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }
  getExpiredGroupsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('expiredGroup', (ref) =>
        ref
          // .where("requestType", "==", "Cancellation")
          .where("hotelId", "==", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getConfirmedGroupsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('group', (ref) =>
        ref
          .where("status", "==", 'confirmed')
          .where("hotelId", "==", hotelId)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getMultiGroupsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('multiGroup', (ref) =>
        ref
          .where("status", "==", 'confirmed')
          .where("hotelId", "==", hotelId)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getMultiGroupsByReqId(hotelId: any, groupId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('multiGroup', (ref) =>
        ref
          .where("groupId", "==", groupId)
          .where("hotelId", "==", hotelId)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getConfirmedBanquetsByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('banquet', (ref) =>
        ref
          .where("status", "==", 'confirmed')
          .where("hotelId", "==", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getCheckOutByHotelId(hotelId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore.collection('room', (ref) =>
        ref
          .where("status", "==", 'checkout')
          .where("hotelData.id", "==", hotelId)
          .where('timeStamp', '>=', startDate)
          .where('timeStamp', '<=', endDate)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getCheckOutByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('room', (ref) =>
        ref
          .where("status", "==", 'checkout')
          .where("corporateData.id", "==", corpId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getCheckOutListByCorpId(corpId: any,hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('room', (ref) =>
        ref
          .where("status", "==", 'checkout')
          .where("corporateData.id", "==", corpId)
          .where("hotelData.id", "==", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getGroupCheckOutListByCorpId(corpId: any, hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('group', (ref) =>
        ref
          .where("status", "==", 'checkout')
          .where("corporateData.id", "==", corpId)
          .where("hotelData.id", "==", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getBanquetCheckOutListByCorpId(corpId: any, hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('banquet', (ref) =>
        ref
          .where("status", "==", 'checkout')
          .where("corporateData.id", "==", corpId)
          .where("hotelData.id", "==", hotelId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }


  getGroupCheckOutByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('group', (ref) =>
        ref
          .where("status", "==", 'checkout')
          .where("corporateData.id", "==", corpId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getBanquetCheckOutByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('banquet', (ref) =>
        ref
          .where("status", "==", 'checkout')
          .where("corporateData.id", "==", corpId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getGroupCheckOutByHotelId(hotelId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore.collection('group', (ref) =>
        ref
          .where("status", "==", 'checkout')
          .where("hotelData.id", "==", hotelId)
          .where('timeStamp', '>=', startDate)
          .where('timeStamp', '<=', endDate)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getBanquetCheckOutByHotelId(hotelId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore.collection('banquet', (ref) =>
        ref
          .where("status", "==", 'checkout')
          .where("hotelData.id", "==", hotelId)
          .where('timeStamp', '>=', startDate)
          .where('timeStamp', '<=', endDate)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getReserveReportConfirmedByHotelId(hotelId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore.collection('room', (ref) =>
        ref
          .where("status", "==", 'confirmed')
          .where("hotelId", "==", hotelId)
          .where('timeStamp', '>=', startDate)
          .where('timeStamp', '<=', endDate)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getReserveReportRejectedByHotelId(hotelId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore.collection('room', (ref) =>
        ref
          .where("status", "==", 'rejected')
          .where("hotelId", "==", hotelId)
          .where('timeStamp', '>=', startDate)
          .where('timeStamp', '<=', endDate)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getRoomAmendmentsByHotelId(hotelId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore.collection('pendingAmend', (ref) =>
        ref
          .where("hotelId", "==", hotelId)
          .where('timeStamp', '>=', startDate)
          .where('timeStamp', '<=', endDate)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getGroupAmendmentsByHotelId(hotelId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore.collection('pendingGroupAmend', (ref) =>
        ref
          .where("hotelId", "==", hotelId)
          .where('timeStamp', '>=', startDate)
          .where('timeStamp', '<=', endDate)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getBanquetAmendmentsByHotelId(hotelId: any, startDate: any, endDate: any) {
    return new Promise((resolve) => {
      this.firestore.collection('pendingBanquetAmend', (ref) =>
        ref
          .where("hotelId", "==", hotelId)
          .where('timeStamp', '>=', startDate)
          .where('timeStamp', '<=', endDate)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  roomCheckout(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.roomCheckoutCollection.add(data);
  }

  groupCheckout(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.groupCheckoutCollection.add(data);
  }

  banquetCheckout(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.banquetCheckoutCollection.add(data);
  }

  approveRejectPendingRoom(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.pendingroomCollection.add(data);
  }

  approveRejectPendingAmend(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.pendingamendCollection.add(data);
  }

  approveRejectPendingCancel(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.pendingcancelCollection.add(data);
  }

  confirmRejectPendingRoom(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.pendingGrouproomCollection.add(data);
  }

  confirmRejectPendingAmend(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.pendingGroupamendCollection.add(data);
  }

  confirmRejectPendingCancel(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.pendingGroupcancelCollection.add(data);
  }

  confirmRejectBanquetRoom(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.pendingBanquetroomCollection.add(data);
  }
  confirmRejectBanquetAmend(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.pendingBanquetamendCollection.add(data);
  }

  confirmRejectBanquetCancellation(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.pendingBanquetcancelCollection.add(data);
  }

  getHotelAutoId() {
    return new Promise((resolve) => {
      let orderNumRef = this.afs.doc('settings/hotel');
      return orderNumRef.ref.get()
        .then(doc => {
          let val = "0001";
          if (doc.exists) {
            val = (Number(doc.data().counter) + 1).toString();
          }
          orderNumRef.ref.set({
            counter: val
          })
          resolve(val);
        })
    })
  }

  getHotelLinkId() {
    return new Promise((resolve) => {
      let orderNumRef = this.afs.doc('settings/hotelLink');
      return orderNumRef.ref.get()
        .then(doc => {
          let val = "0001";
          if (doc.exists) {
            val = (Number(doc.data().counter) + 1).toString();
          }
          orderNumRef.ref.set({
            counter: val
          })
          resolve(val);
        })
    })
  }

  updatePendingRoom(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.afs.doc('pendingRoom/' + data.id).set(data);
  }

  getAllPendingRoooms() {
    return new Promise((resolve) => {
      this.firestore.collection('pendingRoom').snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  updateRoom(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.afs.doc('room/' + data.id).set(data);
  }

  updateGroup(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.afs.doc('group/' + data.id).set(data);
  }

  updateMultiGroup(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.afs.doc('multiGroup/' + data.id).set(data);
  }

  updateBanquet(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.afs.doc('banquet/' + data.id).set(data);
  }

  updateBanquetMaster(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.afs.doc('banquetMaster/' + data.id).set(data);
  }

  updateRejectedBanquet(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.afs.doc('rejectedBanquet/' + data.id).set(data);
  }
  updateExpiredBanquet(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.afs.doc('expiredBanquet/' + data.id).set(data);
  }

  updateRejectedGroup(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.afs.doc('rejectedGroup/' + data.id).set(data);
  }

  updateExpiredGroup(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.afs.doc('expiredGroup/' + data.id).set(data);
  }

  getAllPendingGroups() {
    return new Promise((resolve) => {
      this.firestore.collection('pendingGroupRoom').snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getAllPendingBanquet() {
    return new Promise((resolve) => {
      this.firestore.collection('pendingBanquetRoom').snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getAllSubscriptions() {
    return new Promise((resolve) => {
      this.firestore.collection('subscritionManagement', ref =>
        ref.orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getConfirmRoomById(id: any) {

    return new Promise((resolve) => {
      var docRef = this.firestore.collection("room").doc(id);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  updateLinkClient(data: any) {
    data['timeStamp'] = moment().format('x')
    return this.afs.doc('linkclients/' + data.id).set(data);
  }

  getLinkedClientById(id: any) {

    return new Promise((resolve) => {
      var docRef = this.firestore.collection("linkclients").doc(id);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  getLinkedHotelCorpById(corpId: any, hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('linkclients',
        ref => ref
          .where('corpId', '==', corpId)
          .where('hotelId', '==', hotelId)
          .where('status', '==', 'Corporate Accepted')
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getLinkByHotelCorpId(corpId: any, hotelId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('linkclients',
        ref => ref
          .where('hotelId', '==', hotelId)
          .where('corpId', '==', corpId)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getConfirmGroupById(id: any) {

    return new Promise((resolve) => {
      var docRef = this.firestore.collection("group").doc(id);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  getConfirmedBanquetsById(id: any) {

    return new Promise((resolve) => {
      var docRef = this.firestore.collection("banquet").doc(id);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  getConfirmBanquetById(id: any) {

    return new Promise((resolve) => {
      var docRef = this.firestore.collection("pendingBanquetRoom").doc(id);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  getHotelById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection("hotels").doc(uid);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  getBanquetById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection("banquetMaster").doc(uid);

      docRef.ref.get().then(function(doc) {
        if (doc.exists) {
          let res = { ...doc.data(), id: doc.id }
          resolve(res)
        }
      }).catch(function(error) {
        resolve(null);
      });
    })
  }

  getHotelByTenantId(tenantId: any) {
    return new Promise((resolve) => {
      this.firestore.collection('hotels',
        ref => ref.where('tenantId', '==', tenantId)).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getLiveHotel() {
    return new Promise((resolve) => {
      this.firestore.collection('hotels',
        ref => ref
          .where('status', '==', 'On-Boarding Completed')
          .where('isProcessDone', '==', true)
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  getActiveHotel() {
    return new Promise((resolve) => {
      this.firestore.collection('hotels',
        ref => ref.where('isProcessDone', '==', true)).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

  addHotelReceivables(data: any) {
    data['timeStamp'] = moment().format('x')
    return firebase.firestore().collection('hotelReceivables').add(data);
  }

  getHotelReceivablesByCorpId(corpId: any, hotelId:any) {
    return new Promise((resolve) => {
      this.firestore.collection('hotelReceivables', (ref) =>
        ref
          .where("hotelId", "==", hotelId)
          .where("corpId", "==", corpId)
          .orderBy("timeStamp", "desc")
      ).snapshotChanges()
        .subscribe(users => {
          let contactList = users.map(item => {
            return {
              ...item.payload.doc.data() as {},
              id: item.payload.doc.id
            };
          });
          resolve(contactList);
        })
    })
  }

}
